import { useState, useEffect, useMemo } from 'react';
import { requestGet } from '@/common/request';
import { batchedUpdates } from '@/common/utils';

interface Query {}

interface Response {
  auditNumber: number;
}

export function getTotalAuditNumber(query?: Query): Promise<{ ret: string; msg: string; data: Response }> {
  return requestGet('/activityPlan/getTotalAuditNumber');
}

export function useApiGetTotalAuditNumber() {
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getTotalAuditNumber()
      .then((res) => {
        if (!res || res.ret !== '0') {
          console.log('数据异常', res);
          setLoading(false);
          return;
        }
        batchedUpdates(() => {
          setCount(res.data.auditNumber || 0);
          setLoading(false);
        });
      })
      .catch((ex) => {
        console.error(ex);
        setLoading(false);
      });
  }, []);

  const data = useMemo(() => ({ count, loading }), [count, loading]);

  return [data];
}
